module.exports = __webpack_public_path__ + "img/NB-IoT Icon.a189f832.png";